module.exports = __webpack_public_path__ + "assets/img/zhthree.61e1ee75.png";